import React from 'react';
import CardItem from './CardTableItem';
import DataTableColumn from './DataTableColumn';
import { TableContext } from '../utils/context';

function Column () {
  const { mode } = React.useContext(TableContext);
  return mode === 'card' ? CardItem : DataTableColumn
}
Column.TagName = 'DataTableColumn'
export default Column;